import { useEffect, useState } from 'react';

/**
 * MessagePopup - Message popup with blue/gold broadcast theme.
 * Supports multiple messages (one per line) rotating every 10 seconds.
 */

export function MessagePopup({ messageVisible, messageText, messageExiting }) {
  const messages = String(messageText || '').split('\n').map(s => s.trim()).filter(Boolean);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    setIdx(0);
    if (messages.length <= 1) return;
    const t = setInterval(() => setIdx(prev => (prev + 1) % messages.length), 10000);
    return () => clearInterval(t);
  }, [messageText, messages.length]);

  if (!messageVisible || messages.length === 0) return null;
  const current = messages[idx % messages.length];

  return (
    <div
      data-testid="message-popup"
      style={{
        position: 'absolute',
        bottom: '85px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 45,
        animation: messageExiting ? 'messageExit 0.8s ease-in forwards' : 'messageEnter 0.8s ease-out forwards',
      }}
    >
      <div style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '24px',
        backgroundColor: '#050F23',
        padding: '0',
        minWidth: '612px',
        maxWidth: '1105px',
        border: '2px solid var(--theme-panel-border)',
        boxShadow: `0 0 50px rgba(var(--theme-accent-rgb), 0.25), 0 34px 85px rgba(0,0,0,0.5)`,
        overflow: 'hidden',
        position: 'relative',
      }}>
        <div style={{  padding: '24px 75px', textAlign: 'center' }}>
          <div style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: '1.1rem', fontWeight: 600, color: 'var(--theme-accent)',
            textTransform: 'uppercase', letterSpacing: '7px', marginBottom: '12px',
            animation: messageExiting ? 'none' : 'messageLabelFade 0.8s ease-out 0.3s both',
          }}>
            Informasjon
          </div>
          <div key={idx} style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '2.38rem', fontWeight: 600, color: '#FFFFFF',
            lineHeight: 1.4, whiteSpace: 'pre-wrap',
            textShadow: '0 3px 14px rgba(0,0,0,0.3)',
            animation: messageExiting ? 'none' : 'messageTextReveal 0.6s ease-out both',
          }}>
            {current}
          </div>
          {messages.length > 1 && (
            <div data-testid="message-popup-dots" style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '16px' }}>
              {messages.map((_, i) => (
                <div key={i} style={{
                  width: '9px', height: '9px', borderRadius: '50%',
                  backgroundColor: i === idx % messages.length ? 'var(--theme-accent)' : 'rgba(255,255,255,0.25)',
                }} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
